import React from "react";
import {ICONS} from '../../helpers/helper'

export const ResultLine = (props) => {
  const { children, className } = props;
  return <div className={`cbmap-item-prop ${className}`}>{children}</div>;
};

export const DetailLine = (props) => {
  const { children, className } = props;
  return <div className={`cbmap-details-prop ${className}`}>{children}</div>;
};

export const InfowinLine = (props) => {
  const { children, className } = props;
  return <div className={`cbmap-infowin-prop ${className}`}>{children}</div>;
};

export const HorizonalLine = (props) => {
  return (
    <div className="cbmap-hr"></div>
  );
};

export const Loading = (props) => {
  const {isLoading} = props;
  if (!isLoading) return null;

  return (
    <div className="cbmap-loading">
      <div
        className="cbmap-loader"
          dangerouslySetInnerHTML={{__html: ICONS.LOADER}}
      ></div>
    </div>
  )
}